module.exports = __webpack_public_path__ + "static/media/medical_black.f0aea152.svg";